export function getPropertyCount(property_data) {
  if (property_data?.htlCount) {
    return property_data.htlCount;
  } else if (property_data?.propertyCount?.B2C?.htlCount) {
    return property_data?.propertyCount?.B2C?.htlCount;
  } else {
    return 0;
  }
}
